import { register } from '../../../JavaScript/Utils'

const Header = el => {
  const navigationOffset = el.querySelector('.content-area').offsetTop
  const mainLinks = el.querySelectorAll('.level-1-link')
  const slideouts = el.querySelectorAll('.slideout')
  let activeSlideout = null

  el.style.height = `${el.offsetHeight}px`

  window.addEventListener('scroll', () => { el.classList.toggle('is--sticky', window.pageYOffset > navigationOffset) })

  /* slideouts with JS since nesting and CSS hover no longer work correctly with Safari < 16 */
  const clearSlideouts = () => {
    if (activeSlideout) {
      activeSlideout.classList.remove('is--active')
      activeSlideout = null
    }
  }

  const leaveLink = e => {
    if (e.relatedTarget.classList.contains('slideout-navigation')) {
      return
    }

    clearSlideouts()
  }

  const enterLink = e => {
    const newSlideoutId = e.currentTarget.dataset.targetId

    if (activeSlideout) {
      if (activeSlideout.dataset.slideoutId === newSlideoutId) {
        return
      }

      activeSlideout.classList.remove('is--active')
    }

    const newSlideout = el.querySelector(`[data-slideout-id="${newSlideoutId}"]`)
    newSlideout.classList.add('is--active')
    activeSlideout = newSlideout
  }

  mainLinks.forEach(link => link.addEventListener('mouseenter', enterLink))
  mainLinks.forEach(link => link.addEventListener('mouseleave', leaveLink))
  slideouts.forEach(link => link.addEventListener('mouseleave', clearSlideouts))
}

register('Header', Header)
